import { useState } from 'react';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { ScrollArea } from './ui/scroll-area';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
  DropdownMenuLabel
} from './ui/dropdown-menu';
import {
  Bell,
  Check,
  CheckCheck,
  X,
  Clock,
  AlertCircle,
  UserPlus,
  ShieldCheck,
  CreditCard,
  Trash2,
  RefreshCw,
  Package,
  XCircle
} from 'lucide-react';

import { SubscriptionLimitsCard } from './SubscriptionLimitsCard';
import { usePackageLimits } from '@/hooks/usePackageLimits';

interface SubscriptionDropdownProps {
  className?: string;
}


export const SubscriptionDropdown: React.FC<SubscriptionDropdownProps> = ({ className }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { packageUsage, loading, error } = usePackageLimits();


  const isExpired = packageUsage && !loading && packageUsage.subscription && (
    packageUsage.subscription.status === 'EXPIRED' ||
    new Date(packageUsage.subscription.validUpto) < new Date()
  );




  return (


    <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          className={`relative bg-background hover:bg-accent rounded-lg shadow-sm ${className}`}
        >
          <Package className="w-4 h-4" />
          {isExpired && (
            <span className="absolute -top-1 -right-1 flex h-3 w-3">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-orange-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-orange-500 items-center justify-center">
                <AlertCircle className="w-2 h-2 text-white" />
              </span>
            </span>
          )}
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent className="w-96 bg-popover shadow-lg rounded-lg border border-border p-0" align="end">
        <div className="p-4 border-b border-border">
          <div className="flex items-center justify-between">
            <DropdownMenuLabel className="text-lg font-semibold text-foreground p-0">
              Subscription & Limits
            </DropdownMenuLabel>
            <Badge variant={!isExpired ? 'default' : 'destructive'}>
              {packageUsage?.subscription?.status || 'No Subscription'}
            </Badge>
          </div>
        </div>

        <div className="p-4">
          {error && (
            <div className="p-4 bg-destructive/10 border-l-4 border-destructive">
              <div className="flex items-center">
                <AlertCircle className="w-4 h-4 text-destructive mr-2" />
                <p className="text-sm text-destructive-foreground">{error}</p>
              </div>
            </div>
          )}

          {loading && packageUsage && (
            <div className="p-8 text-center">
              <RefreshCw className="w-6 h-6 animate-spin text-muted-foreground mx-auto mb-2" />
              <p className="text-sm text-muted-foreground">Loading subscription...</p>
            </div>
          )}

          {!loading && !packageUsage && !error && (
            <div className="p-8 text-center">
              <Bell className="w-8 h-8 text-muted-foreground/50 mx-auto mb-3" />
              <p className="text-sm text-muted-foreground font-medium">No subscription</p>
            </div>
          )}
          {packageUsage && (
            <SubscriptionLimitsCard />
          )}

        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
